import React from "react";

import { formatNumber, useTranslation } from "utils";

import { Skeleton, Typography } from "components";

export const FieldsCountSummary = ({
  visibleFieldsCount,
  totalFieldsCount,
  hasFiltersActive,
  fieldsSizeSummary,
  enrolledFieldsCount,
  enrolledFieldsTotalHectares,
  isEnrollmentDataLoading = false,
}: {
  visibleFieldsCount: number;
  totalFieldsCount: number;
  hasFiltersActive: boolean;
  fieldsSizeSummary?: string | null;
  enrolledFieldsCount?: number;
  enrolledFieldsTotalHectares?: number;
  isEnrollmentDataLoading?: boolean;
}) => {
  const { t } = useTranslation(["allFieldView"]);

  return (
    <>
      <Typography variant="paragraph-m" bold className="margin-0">
        {hasFiltersActive
          ? `${visibleFieldsCount}/${totalFieldsCount} ${t("allFieldView:fieldCount", { count: totalFieldsCount })}`
          : `${totalFieldsCount} ${t("allFieldView:fieldCount", { count: totalFieldsCount })}`}
        {fieldsSizeSummary && (
          <Typography variant="paragraph-m" color="grey-600" className="margin-0">
            {` · ${fieldsSizeSummary}`}
          </Typography>
        )}
      </Typography>
      {isEnrollmentDataLoading ? (
        <Skeleton type="block" height="0.75rem" width="4.5rem" className="all-fields-data-table-view-field-header-enrolled-skeleton" />
      ) : (
        <Typography variant="paragraph-s" color="grey-600" className="margin-0">
          {`${enrolledFieldsCount ?? 0} ${t("allFieldView:fieldHeadlineCard.enrolledFields", { count: enrolledFieldsCount })}`}
          {!!enrolledFieldsTotalHectares &&
            ` · ${t("allFieldView:fieldHeadlineCard.enrolledFieldsSize", { size: formatNumber({ number: enrolledFieldsTotalHectares, decimalPlaces: 1 }) })}`}
        </Typography>
      )}
    </>
  );
};

export default FieldsCountSummary;
